/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EntidadeCriteriaDto } from '../models/entidade-criteria-dto';
import { EntidadeDto } from '../models/entidade-dto';
import { EntidadePageDto } from '../models/entidade-page-dto';
import { EstabelecimentoCriteriaDto } from '../models/estabelecimento-criteria-dto';
import { EstabelecimentoDto } from '../models/estabelecimento-dto';
import { EstabelecimentoPageDto } from '../models/estabelecimento-page-dto';


/**
 * Entidades, Estabelecimentos
 */
@Injectable({
  providedIn: 'root',
})
export class EntidadesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getEntidades
   */
  static readonly GetEntidadesPath = '/entidades';

  /**
   * Pesquisar entidades.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEntidades()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntidades$Response(params?: {
    criteria?: EntidadeCriteriaDto;
  }): Observable<StrictHttpResponse<EntidadePageDto>> {

    const rb = new RequestBuilder(this.rootUrl, EntidadesService.GetEntidadesPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntidadePageDto>;
      })
    );
  }

  /**
   * Pesquisar entidades.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEntidades$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntidades(params?: {
    criteria?: EntidadeCriteriaDto;
  }): Observable<EntidadePageDto> {

    return this.getEntidades$Response(params).pipe(
      map((r: StrictHttpResponse<EntidadePageDto>) => r.body as EntidadePageDto)
    );
  }

  /**
   * Path part for operation getEntidade
   */
  static readonly GetEntidadePath = '/entidades/{id}';

  /**
   * Obter entidade por id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEntidade()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntidade$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EntidadeDto>> {

    const rb = new RequestBuilder(this.rootUrl, EntidadesService.GetEntidadePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntidadeDto>;
      })
    );
  }

  /**
   * Obter entidade por id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEntidade$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEntidade(params: {
    id: number;
  }): Observable<EntidadeDto> {

    return this.getEntidade$Response(params).pipe(
      map((r: StrictHttpResponse<EntidadeDto>) => r.body as EntidadeDto)
    );
  }

  /**
   * Path part for operation getEstabelecimentos
   */
  static readonly GetEstabelecimentosPath = '/estabelecimentos';

  /**
   * Pesquisar estabelecimentos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstabelecimentos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstabelecimentos$Response(params?: {
    criteria?: EstabelecimentoCriteriaDto;
  }): Observable<StrictHttpResponse<EstabelecimentoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, EntidadesService.GetEstabelecimentosPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstabelecimentoPageDto>;
      })
    );
  }

  /**
   * Pesquisar estabelecimentos.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEstabelecimentos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstabelecimentos(params?: {
    criteria?: EstabelecimentoCriteriaDto;
  }): Observable<EstabelecimentoPageDto> {

    return this.getEstabelecimentos$Response(params).pipe(
      map((r: StrictHttpResponse<EstabelecimentoPageDto>) => r.body as EstabelecimentoPageDto)
    );
  }

  /**
   * Path part for operation getEstabelecimento
   */
  static readonly GetEstabelecimentoPath = '/estabelecimentos/{id}';

  /**
   * Obter estabelecimento por id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstabelecimento()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstabelecimento$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EstabelecimentoDto>> {

    const rb = new RequestBuilder(this.rootUrl, EntidadesService.GetEstabelecimentoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstabelecimentoDto>;
      })
    );
  }

  /**
   * Obter estabelecimento por id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEstabelecimento$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstabelecimento(params: {
    id: number;
  }): Observable<EstabelecimentoDto> {

    return this.getEstabelecimento$Response(params).pipe(
      map((r: StrictHttpResponse<EstabelecimentoDto>) => r.body as EstabelecimentoDto)
    );
  }

}
